export const specialDates = [
    {
        "name": "ערב ראש השנה תשפ\"ח",
        "fromDate": "2026-09-11",
        "toDate": "2026-09-11",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "ראש השנה",
        "fromDate": "2026-09-12",
        "toDate": "2026-09-13",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "ערב כיפור",
        "fromDate": "2026-09-20",
        "toDate": "2026-09-20",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "יום כיפור",
        "fromDate": "2026-09-21",
        "toDate": "2026-09-21",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "ערב חג סוכות",
        "fromDate": "2026-09-25",
        "toDate": "2026-09-25",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "חול המועד סוכות",
        "fromDate": "2026-09-27",
        "toDate": "2026-10-01",
        "status": "special_hours",
        "startTime": "09:00",
        "endTime": "12:00"
    },
    {
        "name": "שמיני עצרת/ שמחת תורה",
        "fromDate": "2026-10-02",
        "toDate": "2026-10-03",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "חנוכה",
        "fromDate": "2026-12-06",
        "toDate": "2026-12-10",
        "status": "open",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "פורים",
        "fromDate": "2027-03-23",
        "toDate": "2027-03-24",
        "status": "open",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "ערב פסח",
        "fromDate": "2027-04-21",
        "toDate": "2027-04-21",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "פסח",
        "fromDate": "2027-04-22",
        "toDate": "2027-04-22",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "חול המועד פסח",
        "fromDate": "2027-04-25",
        "toDate": "2027-04-27",
        "status": "special_hours",
        "startTime": "09:00",
        "endTime": "12:00"
    },
    {
        "name": "ערב שביעי של פסח",
        "fromDate": "2027-04-28",
        "toDate": "2027-04-28",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "שביעי של פסח",
        "fromDate": "2027-04-29",
        "toDate": "2027-04-29",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "יום השואה",
        "fromDate": "2027-05-04",
        "toDate": "2027-05-04",
        "status": "open",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "יום הזיכרון",
        "fromDate": "2027-05-11",
        "toDate": "2027-05-11",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "יום העצמאות",
        "fromDate": "2027-05-12",
        "toDate": "2027-05-12",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "ערב חג שבועות",
        "fromDate": "2027-06-10",
        "toDate": "2027-06-10",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "שבועות",
        "fromDate": "2027-06-11",
        "toDate": "2027-06-12",
        "status": "closed",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "ערב תשעה באב",
        "fromDate": "2027-08-11",
        "toDate": "2027-08-11",
        "status": "open",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "תשעה באב",
        "fromDate": "2027-08-12",
        "toDate": "2027-08-12",
        "status": "open",
        "startTime": null,
        "endTime": null
    },
    {
        "name": "יום בחירות",
        "fromDate": "2026-10-27",
        "toDate": "2026-10-27",
        "status": "unknown",
        "startTime": null,
        "endTime": null
    }
]